module.exports = __webpack_public_path__ + "static/lines-1e9762593751a8022a849c89a33e13f8.png";